

define(['angular', 'squid/index', 'login/kmliEligibility'], function (angular, squid) {

    (function exportProviders(angular) {
        angular && angular.exportProviders(module, exports, __dirname, __filename);
    })(window.angular);

    angular.module('xo-unified-login.kmliUpsell', ['squid']).factory('$KmliUpsell', function ($pxp, $populate, $rootScope, $CheckoutAppDataModel, $CheckoutCartModel, $AuthModel, $DeviceInfo, $KmliEligibility, $config, $logger, $q) {

        var idToken, successfulLogin, isOneTouched, upsellOptInDisplayed, kmliEligible, ulAsLanding, walletTokenization, preloadUL, lastUpsellVersion; // Model Retrived
        var showReactivationInterstitial, kmliChecked; // Passed in init
        var expPromise; // Promisified experience data
        var scope = {};
        scope.token = $rootScope.token;

        return {

            init: function init(params) {

                if (expPromise) {
                    return; // do not init twice
                }
                $logger.debug('kmliUpsell_init', params);
                expPromise = $KmliEligibility.init().then(function (KmliEligibility) {
                    kmliEligible = Boolean(KmliEligibility.kmliEligibility) && !params.jwtBasedAssertion;
                    ulAsLanding = Boolean(KmliEligibility.ulAsLanding);
                    preloadUL = Boolean(KmliEligibility.preloadUL);
                    return $populate(scope, {
                        auth: $AuthModel.instance(),
                        checkoutCart: $CheckoutCartModel.instance(scope.token),
                        checkoutAppData: $CheckoutAppDataModel.instance(scope.token)
                    });
                }).then(function () {
                    idToken = Boolean(scope.auth.idTokenPresent);
                    successfulLogin = scope.auth.loggedIn();
                    isOneTouched = scope.auth.loggedIn() && scope.auth.refreshToken();
                    walletTokenization = scope.checkoutCart.isWalletTokenization(); // android pay, apple pay, etc
                    kmliChecked = Boolean(params.isKmliSet); // may not be OT but user has already opted in
                    upsellOptInDisplayed = Boolean(scope.auth.upsellOptInDisplayed);
                    lastUpsellVersion = scope.auth.ryiOptIn && scope.auth.ryiOptIn.interstitialDisplayed;
                    showReactivationInterstitial = Boolean(params.showReactivationInterstitial);
                    if (walletTokenization || preloadUL) {
                        // do not trigger pxp for walletTokenization, ulpreload
                        $logger.debug('kmliUpsell_init_ineligible');
                        return $q.resolve();
                    }

                    return $pxp($config.ulMeta.pxpExpId, {
                        'ctx.COUNTRY': scope.checkoutAppData.merchant.merchant_country,
                        'ctx.CHANNEL': $DeviceInfo.isMobile() || $DeviceInfo.isTablet() ? 'MOBILE' : 'WEB'
                    }, 'xo_hermes_kmli_upsell_(web|mobile)_treatment.*');
                }).then(function (pxpRes) {
                    var experience = pxpRes ? { name: pxpRes.treatment_name } : '';
                    lastUpsellVersion = lastUpsellVersion ? lastUpsellVersion : upsellOptInDisplayed ? 0.1 : 0.0;
                    // for lastUpsellVersion use 0.1 when poma and not ryi case else use 0
                    if (pxpRes && pxpRes.factors) {
                        var factors = pxpRes.factors.reduce(function (out, factor) {
                            out[factor.name] = factor.value;
                            return out;
                        }, {});
                        experience.version = +factors.version > +lastUpsellVersion;
                        experience.color = factors.color;
                        experience.pxpVersion = factors.version;
                    }
                    return experience;
                });
            },

            eligible: function eligible() {
                var eligibility = {};
                if (!expPromise) {
                    $logger.debug('kmliUpsell_init_not_executed');
                    return $q.resolve(eligibility);
                }
                return expPromise.then(function (experience) {
                    var activeOT = experience && isOneTouched;
                    var regularLogin = experience && kmliEligible && idToken;
                    eligibility.banner = activeOT || regularLogin;
                    eligibility.interstitial = {
                        eligible: eligibility.banner && !isOneTouched // dont show interstitial for OT
                        && !kmliChecked // to handle cases where not OT but already optedin
                        && (experience.name.slice(-1) == '1' || experience.name.slice(-1) == '3') // use only treatment 1,3 for interstitial
                        && experience.version,
                        type: showReactivationInterstitial ? 'reactivation' : successfulLogin ? 'member' : '',
                        color: experience && experience.color,
                        pxpVersion: experience && experience.pxpVersion
                    };
                    $logger.debug('kmliUpsell_eligibility', {
                        eligibility: eligibility,
                        experience: experience,
                        cases: {
                            activeOT: activeOT,
                            regularLogin: regularLogin
                        }
                    });
                    return eligibility;
                });
            },

            getOptions: function getOptions() {

                if (showReactivationInterstitial) {
                    return {
                        flowName: 'expiredUpsell'
                    };
                }
            },

            getFPTIAttributes: function getFPTIAttributes() {

                if (showReactivationInterstitial) {
                    return {
                        stateName: 'KMLI_reactivation',
                        transInfix: '_kmli_reactivation_'
                    };
                } else {
                    return {
                        stateName: 'KMLI_UPSELL',
                        transInfix: '_kmli_upsell_'
                    };
                }
            }
        };
    });
});


//////////////////
// WEBPACK FOOTER
// ./components/xo-login-components/src/onetouch-interstitial/kmliUpsell.js
// module id = ./components/xo-login-components/src/onetouch-interstitial/kmliUpsell.js
// module chunks = 1